import I18n from '../../config/i18n';

import { stringArrayToObject } from '../../utils/array';

import { loadFullCollections } from '../../services/DatabaseService';
import { createCollection, updateCollection } from '../../services/CollectionServices';

import { actionCreators as toastActions } from '../Toasts/actions';

/* ------------- Country actions ------------- */
export const actions = stringArrayToObject(
  ['LOAD_START', 'LOAD_SUCCESS', 'LOAD_FAIL', 'CLOSE_MODAL', 'OPEN_MODAL', 'ADD_COLLECTION', 'UPDATE_COLLECTION'],
  '@PRODUCT_COLLECTIONS',
);

const privateActionCreators = {
  loadStart(page, { search }) {
    return {
      type: actions.LOAD_START,
      payload: { page, search },
    };
  },
  loadSuccess(list) {
    return {
      type: actions.LOAD_SUCCESS,
      payload: { list },
    };
  },
  loadFailure(err) {
    return {
      type: actions.LOAD_FAIL,
      payload: { err },
    };
  },
  addCollection(collection) {
    return {
      type: actions.ADD_COLLECTION,
      payload: { collection },
    };
  },
  updateCollection(collection) {
    return {
      type: actions.UPDATE_COLLECTION,
      payload: { collection },
    };
  },
};

export const actionCreators = {
  load(page = 1, options = {}) {
    return async (dispatch) => {
      dispatch(privateActionCreators.loadStart(page, options));
      const response = await loadFullCollections(page, options);
      if (response.ok) {
        dispatch(privateActionCreators.loadSuccess(response.list));
      } else {
        dispatch(privateActionCreators.loadFailure(response.error));
      }
    };
  },
  createCollection(collection) {
    return async (dispatch) => {
      const response = await createCollection(collection);
      if (response.ok) {
        dispatch(toastActions.addToast({
          type: 'success',
          message: I18n.t('forms.newCollection.messages.created'),
        }));
        dispatch(privateActionCreators.addCollection(response.collection));
      } else {
        dispatch(privateActionCreators.loadFailure(response.error));
        dispatch(toastActions.addToast({
          type: 'error',
          message: response.error,
        }));
      }
    };
  },
  updateCollection(id, collection) {
    return async (dispatch) => {
      const response = await updateCollection(id, collection);
      if (response.ok) {
        dispatch(toastActions.addToast({
          type: 'success',
          message: I18n.t('forms.newCollection.messages.updated'),
        }));
        dispatch(privateActionCreators.updateCollection(response.collection));
      } else {
        dispatch(privateActionCreators.loadFailure(response.error));
        dispatch(toastActions.addToast({
          type: 'error',
          message: response.error,
        }));
      }
    };
  },
  closeModal() {
    return {
      type: actions.CLOSE_MODAL,
    };
  },
  openModal() {
    return {
      type: actions.OPEN_MODAL,
    };
  },
};



// WEBPACK FOOTER //
// ./src/redux/ProductCollections/actions.js